import { QuestionIcon } from '@/icons';
import { COLORS, pickThemeFontStyles } from '@/theme';
import styled from 'styled-components';

export const StyledContentBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
`;

export const StyledLabel = styled.div`
  color: ${COLORS.IRON_GRAY};
  ${pickThemeFontStyles('14', '22', 'NORMAL')};
`;

export const StyledValue = styled.div`
  color: ${COLORS.BLACK_PRIMARY};
  overflow-wrap: anywhere;
  word-break: break-word;
`;

export const StyledPaymentStatusRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
`;

export const StyledTooltipWrap = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const StyledTooltipIcon = styled(QuestionIcon)`
  cursor: pointer;
`;

export const StyledPaymentBlock = styled.div`
  margin-top: 1rem;
`;
